import type { AvatarProps } from './Avatar.types.js';
import { sizes } from './Avatar.utils.js';

export const useStyles = ({ size, onClick }: Pick<AvatarProps, 'size' | 'onClick'>) => ({
  ...sizes[size],
  cursor: onClick ? 'pointer' : '',
});
